module.exports = __webpack_public_path__ + "static/ball-5136a73598f9edce93b462b1cf812ce0.png";